import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { GlobalFiltersInPage } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import { ActivityCodesFilter } from 'components/common/GlobalFiltersInPage/components/ActivityCodesFilter/ActivityCodesFilter';
import { ActivityTypeFilter } from 'components/common/GlobalFiltersInPage/components/ActivityTypeFilter/activityTypeFilter';
import { MilestoneFragnetFilter } from 'components/common/GlobalFiltersInPage/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { TagsFilter } from 'components/common/GlobalFiltersInPage/components/TagsFilter/TagsFilter';
import { WbsFilter } from 'components/common/GlobalFiltersInPage/components/WbsFilter/wbsFilter';
import { DateRangeFilter } from 'components/common/GlobalFiltersInPage/components/dateRangeFilter/dateRangeFilter';
import { ProductivityPreDefinedFilter } from 'components/common/GlobalFiltersInPage/components/productivityPreDefinedFilter/productivityPreDefinedFilter';
import { GlobalFilterFieldKey } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';

import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { TreeProgramTopHeader, VersionCompareSelectorWrapper } from 'components/common';
import { ProductivityTable } from 'components/widgets/RunRateActivitiesDrilldown/productivityTable';
import { ProductivityRate } from 'components/widgets/RunRateChart/productivityRate';

export const ProductivityPage = () => {
    useFullStoryPageView({ pageName: executionConfig.productivity.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader>
                            <ShareInsightButton
                                title={executionConfig.productivity.title}
                                link={window.location.href}
                            />
                            <GlobalFilterButton />
                            <VersionCompareSelectorWrapper isBaselineSelected={true} allowSingleVersion={true} />
                        </TreeProgramTopHeader>
                    </VersionSection>
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={executionConfig.productivity.title} />
                    <GlobalFiltersInPage
                        defaultValues={{
                            [GlobalFilterFieldKey.dateRangeFilter]: 'R_4W',
                            [GlobalFilterFieldKey.productivityPreDefined]: null,
                            [GlobalFilterFieldKey.activityType]: 'ALL',
                            [GlobalFilterFieldKey.milestoneFragnet]: null,
                            [GlobalFilterFieldKey.tags]: [],
                            [GlobalFilterFieldKey.activityCodes]: [],
                            [GlobalFilterFieldKey.wbs]: null,
                        }}
                    >
                        <DateRangeFilter name={GlobalFilterFieldKey.dateRangeFilter} />
                        <ProductivityPreDefinedFilter name={GlobalFilterFieldKey.productivityPreDefined} />
                        <ActivityTypeFilter name={GlobalFilterFieldKey.activityType} />
                        <MilestoneFragnetFilter name={GlobalFilterFieldKey.milestoneFragnet} />
                        <TagsFilter name={GlobalFilterFieldKey.tags} />
                        <ActivityCodesFilter name={GlobalFilterFieldKey.activityCodes} />
                        <WbsFilter name={GlobalFilterFieldKey.wbs} />
                    </GlobalFiltersInPage>
                </BottomHeaderSection>
            </HeaderWrapper>

            <MainContent>
                <PageWidgetWrapper>
                    <ProductivityRate />
                    <ProductivityTable />
                </PageWidgetWrapper>
            </MainContent>
            <MainCardRoutingModal queryKeys={['getStoredTags']} />
        </PageContainer>
    );
};
